import React, {useState} from "react";
import get from "lodash/get";
import { object } from "prop-types";
import PropTypes from "react-modal";
import { ShowMoreBtn } from "../../atoms/show-more-btn";
import { collectionToStories, Link } from "@quintype/components";
import CardImageType8 from "../../molecules/card-image-type-8";
import CardImageType4 from "../../molecules/card-image-type-4";
import { SectionCategoryTitle } from "../../molecules/section-category-title";
//import CollectionEnd from "../../molecules/collection-end";
import "./one-big-10-small-img-news-rows.m.css";

const OneBigTenSmallImgNewsRows = ({ collection }) => {
  const theme = get(collection, ["associated-metadata", "dark_bg"], false);
  const showSection = get(collection, ["associated-metadata", "Näytä_kokoelman_otsikko"], false);
  const storiesFromCollection = collectionToStories(collection);

  if (storiesFromCollection.length < 1) {
    return null;
  }

  const [firstStory, ...restOftheStories] = storiesFromCollection;
  const [visibleCount, setVisibleCount] = useState(10);
  const increment = 10;
  const hasMoreToShow = visibleCount < restOftheStories.length;

  const handleShowMore = () => {
    setVisibleCount((prev) => Math.min(prev + increment, restOftheStories.length));
  };

  return (
    <React.Fragment>
      <div styleName={`wrapper ${theme ? "dark-bg" : "light-bg"}`}>
        <div styleName="container">
          <div styleName="inner-wrapper1">
            {showSection && (
              <div>
                <SectionCategoryTitle name={collection.name} />
              </div>
            )}

            <div styleName="first-story first-story1">
              <CardImageType4 story={firstStory} showSubHeadline={false} />
            </div>

            <div styleName="item-wrapper1">
              {restOftheStories.length >= 1 &&
                restOftheStories.slice(0, visibleCount).map((item, index) => (
                  <React.Fragment key={index}>
                    <div styleName="item" className="item" key={item.id}>
                      <CardImageType8 story={item} showSubHeadline={false} />
                    </div>
                  </React.Fragment>
                ))}
            </div>

            {hasMoreToShow && (
              <div style={{ textAlign: "center", marginTop: "1rem" }}>
                <ShowMoreBtn loadMore={handleShowMore} btnName="NÄYTÄ LISÄÄ" />
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

OneBigTenSmallImgNewsRows.propTypes = {
  collection: PropTypes.object,
};

export { OneBigTenSmallImgNewsRows };
//OneBigTenSmallImgNewsRows.storyLimit = 30;
